import useIsAuthenticated from '@/app/hooks/useIsAuthenticated';
import useUserRoles from '@/app/hooks/useUserRoles';
import { NotFound } from '@/app/ui/components/not-found';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslations } from 'use-intl';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
} from '@/app/ui/components/breadcrumb';
import {
  Header,
  HeaderCopyButton,
  HeaderOrganizationMenu,
  HeaderSidebarTrigger,
} from '@/app/ui/components/header';
import { MainScrollArea } from '@/app/ui/components/main';
import { HugeiconsIcon } from '@hugeicons/react';
import { Building06Icon } from '@hugeicons/core-free-icons';
import AdminOrganizationsList from '@/app/components/features/adminOrganizations/AdminOrganizationsList';
import { validator } from '@/app/validator';
import { z } from 'zod';

export const Route = createFileRoute('/_authed/(organization)/_layout/admin/organizations')({
  component: RouteComponent,
  validateSearch: validator(
    z.object({
      highlightedOrganization: z.string().optional(),
    }),
  ),
});

function RouteComponent() {
  const t = useTranslations('pages.adminOrganizations');
  const { isSystemAdmin } = useUserRoles();
  const isAuthenticated = useIsAuthenticated();

  if (isAuthenticated && !isSystemAdmin) return <NotFound />;

  return (
    <>
      <Header>
        <HeaderOrganizationMenu />
        <HeaderSidebarTrigger />
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbPage>
                <HugeiconsIcon icon={Building06Icon} />
                {t('heading')}
              </BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
        <HeaderCopyButton />
      </Header>
      <MainScrollArea>
        <AdminOrganizationsList />
      </MainScrollArea>
    </>
  );
}
